// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4624":"4a07416662d2c07e","8625":"377b76fb94794b2d"}[chunkId] + ".css";
};